import(/* webpackMode: "eager" */ "/opt/build/repo/frontend/app/global-error.tsx");
